import React from "react";
import Moveable from "react-moveable";
import {
  useScreenshotRectangleStore,
  useWidePopupStore,
} from "../../../api/Zustand";
import { useUbiVision } from "../../../api/calls/OpenAi";
import { generateImage } from "../OpenAi/OpenAiWrapper";
import { useGLRendererStore } from "../../../state management/zustand/gl-stores";

const ScreenshotRectangle = (props: {
  el: React.RefObject<HTMLDivElement>;
}) => {
  const draggableRef = React.useRef<HTMLDivElement>(null);

  const executeOnce = React.useRef<boolean>(false);

  const { setPosition, position, setImage, resetImage } =
    useScreenshotRectangleStore();

  const { isTakingScreenshot, setVisionIsLoading } = useWidePopupStore();

  const { state } = useGLRendererStore();

  const { mutateAsync: mutateVision, isPending: visionIsPending } =
    useUbiVision();

  React.useEffect(() => {
    setVisionIsLoading(visionIsPending);
  }, [setVisionIsLoading, visionIsPending]);

  async function ImageToText() {
    if (state) {
      generateImage(state).then((image: string) => {
        // mutateVision({ image: image });

        setImage(image);
        widePopup.setTakingScreen(false);
      });
    }
  }

  const moveRectangle = React.useCallback(() => {
    const wholeWrapper = props.el.current?.getBoundingClientRect();
    const element = draggableRef.current?.getBoundingClientRect();
    let rectPosition: {
      x: number;
      y: number;
      w: number;
      h: number;
      bottomSpace: boolean;
    };

    if (wholeWrapper && element) {
      rectPosition = {
        x: element.x - wholeWrapper.x,
        y: element.y - wholeWrapper.y,
        h: element.height,
        w: element.width,
        bottomSpace: wholeWrapper.height - (element.height + element.y) > 50,
      };

      setDragging(false);

      return setPosition(rectPosition);
    }
  }, [props.el, setPosition]);

  React.useEffect(() => {
    if (executeOnce.current) {
      return;
    } else {
      const wholeWrapper = props.el.current?.getBoundingClientRect();

      const rectInitialSize = 200;

      if (wholeWrapper?.width && wholeWrapper.height) {
        setPosition({
          x: 50,
          y: 25,
          bottomSpace: true,
          h: rectInitialSize,
          w: rectInitialSize,
        });
      }
      executeOnce.current = true;
    }
  }, [props.el, setPosition]);

  const [dragging, setDragging] = React.useState<boolean>(false);

  const widePopup = useWidePopupStore();
  return (
    <>
      <div
        ref={draggableRef}
        style={{
          visibility: isTakingScreenshot ? "visible" : "hidden",

          width: 200,
          height: 200,
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          background: "#fff4",
          zIndex: 100,
        }}
      >
        <div
          style={{
            display: dragging ? "none" : "block",
            position: "absolute",
            top: position.bottomSpace ? "104%" : "auto",
            bottom: position.bottomSpace ? "auto" : "104%",

            left: "50%",
            transform: "translate(-50%)",
            minWidth: "max-content",
          }}
        >
          <button
            className="draggable-rec"
            id="annulla"
            onMouseDown={() => {
              resetImage();
              widePopup.setTakingScreen(false);
            }}
          >
            Annulla
          </button>
          <button
            className="draggable-rec"
            id="confirm"
            onMouseDown={() => ImageToText()}
          >
            Conferma
          </button>
        </div>
      </div>

      {isTakingScreenshot && (
        <Moveable
          dragArea={false}
          onDragEnd={moveRectangle}
          onResizeEnd={moveRectangle}
          target={draggableRef}
          draggable={true}
          resizable={true}
          throttleDrag={1}
          origin={false}
          edgeDraggable={true}
          startDragRotate={0}
          throttleDragRotate={0}
          onDrag={(e) => {
            setDragging(true);
            e.target.style.transform = e.transform;
          }}
          onResize={(e) => {
            setDragging(true);
            e.target.style.width = `${e.width}px`;
            e.target.style.height = `${e.height}px`;
            e.target.style.transform = e.drag.transform;
          }}
        ></Moveable>
      )}
    </>
  );
};

export default ScreenshotRectangle;
